const FOOD_ITEMS = [
  // Breakfast
  { name: "Daliya", price: 60, image: "/images/food/daliya.jpg", category: "Quick Veg Bites" },
  { name: "Khichdi", price: 70, image: "/images/food/khichdi.jpg", category: "Quick Veg Bites" },
  { name: "Aloo Paratha", price: 50, image: "/images/food/aloo-paratha.jpg", category: "Quick Veg Bites" },
  { name: "Gobhi Paratha", price: 50, image: "/images/food/gobhi-paratha.jpg", category: "Quick Veg Bites" },
  { name: "Paneer Paratha", price: 60, image: "/images/food/paneer-paratha.jpg", category: "Quick Veg Bites" },
  { name: "Mix Paratha", price: 55, image: "/images/food/mix-paratha.jpg", category: "Quick Veg Bites" },
  { name: "Poha", price: 50, image: "/images/food/poha.jpg", category: "Quick Veg Bites" },
  { name: "Aaloo Puri", price: 90, image: "/images/food/puri-bhaji.jpg", category: "Quick Veg Bites" },

  // Sweets
  { name: "Samak Kheer", price: 80, image: "/images/food/samak-kheer.jpg", category: "Sweets" },
  { name: "Sabudana Kheer", price: 80, image: "/images/food/sabudana-kheer.jpg", category: "Sweets" },
  { name: "Makhana Kheer", price: 100, image: "/images/food/makhana-kheer.jpg", category: "Sweets" },
  { name: "Meethi Seviyan", price: 70, image: "/images/food/meethi-seviyan.jpg", category: "Sweets" },
  { name: "Rice Kheer", price: 80, image: "/images/food/rice-kheer.jpg", category: "Sweets" },
  { name: "Lauki Halwa", price: 80, image: "/images/food/lauki-halwa.jpg", category: "Sweets" },

  // Sabzi
  { name: "Jeera Aloo", price: 105, image: "/images/food/jeera-aloo.jpg", category: "Sabzi" },
  { name: "Aloo Gobi", price: 115, image: "/images/food/aloo-gobi.jpg", category: "Sabzi" },
  { name: "Aloo Matar", price: 115, image: "/images/food/aloo-matar.jpg", category: "Sabzi" },
  { name: "Matar Masala", price: 125, image: "/images/food/matar-masala.jpg", category: "Sabzi" },
  { name: "Mushroom Matar Masala", price: 155, image: "/images/food/mushroom-matar-masala.jpg", category: "Sabzi" },
  { name: "Methi Matar", price: 135, image: "/images/food/methi-matar.jpg", category: "Sabzi" },
  { name: "Mix Veg", price: 125, image: "/images/food/mix-veg.jpg", category: "Sabzi" },
  { name: "Lauki", price: 100, image: "/images/food/lauki.jpg", category: "Sabzi" },
  { name: "Tori", price: 100, image: "/images/food/tori.jpg", category: "Sabzi" },

  // Dal & Legumes
  { name: "Dal Fry", price: 115, image: "/images/food/dal-fry.jpg", category: "Dal & Legumes" },
  { name: "Dal Tadka", price: 125, image: "/images/food/dal-tadka.jpg", category: "Dal & Legumes" },
  { name: "Mix Dal", price: 125, image: "/images/food/mix-dal.jpg", category: "Dal & Legumes" },
  { name: "Rajma", price: 135, image: "/images/food/rajma.jpg", category: "Dal & Legumes" },
  { name: "Chole", price: 135, image: "/images/food/chole.jpg", category: "Dal & Legumes" },
  { name: "Chana Masala", price: 135, image: "/images/food/chana-masala.jpg", category: "Dal & Legumes" },

  // Paneer
  { name: "Matar Paneer", price: 175, image: "/images/food/matar-paneer.jpg", category: "Paneer" },
  { name: "Paneer Masala", price: 185, image: "/images/food/paneer-masala.jpg", category: "Paneer" },
  { name: "Kadai Paneer", price: 195, image: "/images/food/kadai-paneer.jpg", category: "Paneer" },
  { name: "Shahi Paneer", price: 200, image: "/images/food/shahi-paneer.jpg", category: "Paneer" },
  { name: "Paneer Bhurji", price: 185, image: "/images/food/paneer-bhurji.jpg", category: "Paneer" },
  { name: "Onion Paneer Bhurji", price: 195, image: "/images/food/onion-paneer-bhurji.jpg", category: "Paneer" },

  // Rice & Roti
  { name: "Rice", price: 40, image: "/images/food/rice.jpg", category: "Rice & Roti" },
  { name: "Jeera Rice", price: 60, image: "/images/food/jeera-rice.jpg", category: "Rice & Roti" },
  { name: "Veg Pulao", price: 100, image: "/images/food/veg-pulao.jpg", category: "Rice & Roti" },
  { name: "Twa Roti", price: 8, image: "/images/food/roti.jpg", category: "Rice & Roti" },
  { name: "Butter Twa Roti", price: 12, image: "/images/food/butter-roti.jpg", category: "Rice & Roti" },
  
  // Plates
  { name: "Simple Thali(Dal, Seasonal Vegetable, 4 Chapati, Rice and Salad)", price: 120, image: "/images/food/simple-thali.jpg", category: "Plate" },
  { name: "Paneer Thali(Paneer, Seasonal Vegetable, 4 Chapati, Rice and Salad)", price: 200, image: "/images/food/paneer-thali.jpg", category: "Plate" },
];

export default FOOD_ITEMS;
